export const ANNOTATION_TOOL_TYPES = {
  FEATURE_TOOL: 'FEATURE_TOOL',
  MEASUREMENT_TOOL: 'MEASUREMENT_TOOL',
  PDF_HIGHLIGHT_TOOL: 'PDF_HIGHLIGHT_TOOL',
  SELECTOR_TOOL: 'SELECTOR_TOOL',
};

export const CHANNEL_TYPES = {
  ACTIONS: 'actions',
  MSC: 'msc',
  PENN: 'penn',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
};

export const CHAT_DRAWER_STATE = {
  EXTERNAL: 'EXTERNAL',
  TEAM: 'TEAM',
  REQS_REVIEW: 'REQS_REVIEW',
};

export const PAGE_SOURCE = {
  BAQ: 'BAQ',
  VIEWER: 'VIEWER',
  REQS_REVIEW: 'REQS_REVIEW',
};
